import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { ButtonBack } from "../Button/Back";
import {getMessagemErro} from "../../utils/erro";
import api from "../../services/api";
import './Contract.css';
import { ContractDetails } from "./ContractDetails";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const APIContractGroupEdit =

withRouter(

// redux
connect(
	(mapStateToProps),  
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				contrato: {},
				contratoApis: [],
				grupos: [],
				grupo: {
					id: '',
					nome: '',
					contrato: '', 
					contratosAplicacoesFornecedoras: [],
				},
				exibeModalExcluir: false,
				botoesHabilitados: true,
				edicaoPermitida: false,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleSelecionaChange = this.handleSelecionaChange.bind(this);
			this.handlePrincipalChange = this.handlePrincipalChange.bind(this);
			this.isContratoApiSelecionado = this.isContratoApiSelecionado.bind(this);
			this.carregarAPIsContrato = this.carregarAPIsContrato.bind(this);
			this.carregarGruposContrato = this.carregarGruposContrato.bind(this);
			this.salvar = this.salvar.bind(this);
			this.editarGrupo = this.editarGrupo.bind(this);
			this.excluirGrupo = this.excluirGrupo.bind(this);
			this.limpar = this.limpar.bind(this);
			this.confirmarExclusao = this.confirmarExclusao.bind(this);
			this.fecharModais = this.fecharModais.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
						<Message />
						<Loading />
						
						<div  style={{margin: "10px"}}>
							<h1>Cadastro de Contrato - Grupos de API'S</h1>
						</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;
			const user = this.props.user;

			if(id){
				api.get(`/api/contrato/${id}`)
					.then(response => { 
						const contrato = response.data;
						const edicaoPermitida = (user.isAdministrador === true && contrato.contratoSerpro === false) || (user.isMantenedor === true  && contrato.contratoSerpro === true);
						this.setState(prevState => ({ ...prevState, contrato, edicaoPermitida,}))
					})
					.catch(erro => {
						console.log("Não foi possível recuperar o contrato " + erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					});
			}

			this.carregarGruposContrato();
			this.carregarAPIsContrato();
		}

		carregarGruposContrato(){
			const id = this.props.match.params.id;
			if(id){
				api.get(`/api/contrato/${id}/grupo-apis`)
					.then(response => { 
						this.setState(prevState => ({ ...prevState, grupos: response.data }))
					})
					.catch(erro => {
						console.log("Não foi possível recuperar os grupos de APIs do contrato " + erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					});
			}
		}

		carregarAPIsContrato(){
			const id = this.props.match.params.id;
			if(id){
				api.get(`/api/contrato/${id}/contrato-apis`)
					.then(response => { 
						const contratoApis = response.data;
						this.setState(prevState => ({ ...prevState, contratoApis }))
					})
					.catch(erro => {
						console.log("Não foi possível recuperar as APIs do contrato " + erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					});
			}
		}

		renderForm() {
			const { contrato, grupo, grupos, contratoApis, edicaoPermitida } = this.state;

			return(
				<div className="container-fluid">
					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalExcluir}
						handleOk={() => this.excluirGrupo()}
						handleCancel={() => this.fecharModais()}
						message="Deseja realmente remover o grupo de API?"/>

					<div className="br-form">
						<ContractDetails contrato={contrato} />

						{edicaoPermitida &&
							<>
								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="nome">Nome:</label>
												<input type="text" id="nome" name="nome"
													value={grupo.nome}  
													onChange={this.handleInputChange} 
													maxLength="60"
													disabled={!edicaoPermitida}
												/>
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="nome">APis do grupo:</label>
											</div>
											<div>
												<div className="br-table">						
													<div className="table">
														<table>
															<thead>
																<tr>
																	<th scope="col" className="text-center" style={{width: "5%"}}>Selecionar</th>
																	<th scope="col">API</th>
																	<th scope="col" className="text-center" style={{width: "5%"}}>Principal</th>
																</tr>
															</thead>
															
															<tbody>
																{ contratoApis.map((contratoApi, index) => {
																		const contratoApiSelecionado = this.isContratoApiSelecionado(contratoApi);
																		const contratoApiPrincipal = this.isContratoApiPrincipal(contratoApi);

																		return (
																		<tr key={index} >
																			<td className="text-center"><input type="checkbox" id="seleciona" name="seleciona" checked={contratoApiSelecionado} onChange={this.handleSelecionaChange} value={contratoApi.id} /></td>
																			<td>{contratoApi.nomeFornecedora}</td>
																			<td className="text-center"><input type="checkbox" id="principal" name="principal" checked={contratoApiPrincipal} disabled={!contratoApiSelecionado} onChange={this.handlePrincipalChange} value={contratoApi.id}/></td>
																		</tr>
																		)}
																	)}
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

							</>

						}

						<div className="actions-button">
							<div className="actions justify-content-start">
								{ edicaoPermitida &&
									<>
										{! grupo.id &&
											<button type="button" className="button is-primary" onClick={this.salvar} disabled={this.state.botoesHabilitados === false}>Incluir</button>
										}

										{grupo.id &&
											<button type="button" className="button is-primary" onClick={this.salvar} disabled={this.state.botoesHabilitados === false}>Alterar</button>
										}

										<button type="button" className="button is-secondary" onClick={this.limpar} disabled={this.state.botoesHabilitados === false}>Limpar</button>
									</>
								}
								
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
						
						<fieldset>
							<legend>Grupos de API's cadastrados</legend>
							{(grupos && grupos.length > 0) &&	
								<div className="br-table">						
									<div className="table">
										<table>
											<thead>
												<tr>
												<th scope="col">Nome</th>
												<th scope="col" >API's</th>
												{ edicaoPermitida &&
													<th className="text-center" scope="col">Ações</th>
												}
												</tr>
											</thead>
											
											<tbody>
												{ grupos.map((grupo, index) =>
														<tr key={index} >
															<td>{grupo.nome}</td>
															<td>
																{(grupo.contratosAplicacoesFornecedoras && grupo.contratosAplicacoesFornecedoras.length > 0) && 
																	<ul>{grupo.contratosAplicacoesFornecedoras.map(caf => <li>{caf.nomeFornecedora} {caf.principal && '(Principal)'}</li>)}</ul>
																}
															</td>
															{ edicaoPermitida &&
																<td className="text-center">
																	<div className="actions">
																		<button type="button" onClick={() => this.confirmarExclusao(grupo)} disabled={this.state.botoesHabilitados === false} title="Excluir grupo de API's">
																			<span className="sr-only">Excluir</span>
																			<i className="fas fa-trash"></i>
																		</button>

																		<button type="button" onClick={() => this.editarGrupo(grupo.id)} disabled={this.state.botoesHabilitados === false} title="Editar grupo de API's">
																			<span className="sr-only">Editar</span>
																			<i className="fas fa-edit"></i>
																		</button>
																	</div>
																</td>
															}
														</tr>
													)}
											</tbody>
										</table>
									</div>
								</div>
							}

							{(! grupos || grupos.length === 0) &&
								<div>
									Nenhum grupo de API cadastrado no contrato.
								</div>
							}
						</fieldset>
					</div>

				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const grupo = this.state.grupo;
			grupo[nome] = valor;
			this.setState(prevState => ({ ...prevState, grupo }));
		}

		handleSelecionaChange(evento){
			const target = evento.target;
			const idContratoApi = parseInt(target.value);
			const selecionado = target.checked;

			const grupo = this.state.grupo;
			
			if(selecionado){
				const contratoApi = this.state.contratoApis.find(contratoApi => contratoApi.id === idContratoApi);
				grupo.contratosAplicacoesFornecedoras.push({...contratoApi, principal: false});
			} else {
				const indiceContratoApi = grupo.contratosAplicacoesFornecedoras.findIndex(contratoApi => contratoApi.id === idContratoApi);
				if(indiceContratoApi !== -1){
					grupo.contratosAplicacoesFornecedoras.splice(indiceContratoApi, 1);
				}
			}

			this.setState(prevState => ({ ...prevState, grupo }));
		}

		isContratoApiSelecionado(contratoApi){
			const grupo = this.state.grupo;
			return grupo.contratosAplicacoesFornecedoras.some(contratoApiGrupo => contratoApiGrupo.id === contratoApi.id);
		}

		handlePrincipalChange(evento){
			const target = evento.target;
			const idContratoApi = parseInt(target.value);
			const selecionado = target.checked;

			const { grupo } = this.state;

			grupo.contratosAplicacoesFornecedoras.forEach((contratoApi) => contratoApi['principal'] = contratoApi.id === idContratoApi && selecionado);

			this.setState(prevState => ({ ...prevState, grupo }));
		}

		isContratoApiPrincipal(contratoApi){
			const grupo = this.state.grupo;
			return grupo.contratosAplicacoesFornecedoras.some(contratoApiGrupo => contratoApiGrupo.id === contratoApi.id && contratoApiGrupo.principal === true);
		}
		
		salvar(e){
			this.props.limpaMensagem();

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			this.setState(prevState => ({ ...prevState, botoesHabilitados: false }));
			const {contrato, grupo} = this.state;
			grupo.contrato = contrato.id;
			const method = grupo.id ? 'put' : 'post';
			let url = `/api/contrato/grupo-api`;

			const options = {
				method,
				url,
				"data" : grupo,
			}
			this.props.mostraAguardando();

			api(options)
				.then(response => {
					const mensagem = `API ${grupo.id ? 'alterado' : 'incluído'} com sucesso!`;
					this.carregarGruposContrato();
					this.setState(prevState => ({ ...prevState, grupo: {id: '', nome: '', contratosAplicacoesFornecedoras: []}}))
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${grupo.id ? 'alterar' : 'incluir'} o grupo de API's.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState(prevState => ({ ...prevState, botoesHabilitados: true }));
					this.props.escondeAguardando();
				});   

		}

		editarGrupo(idGrupo){
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			this.setState(prevState => ({ ...prevState, botoesHabilitados:false}));
		
			api.get(`/api/contrato/grupo-api/${idGrupo}`)
				.then(response => {
					this.setState(prevState => ({ ...prevState, grupo: response.data }));
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar o grupo de API.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					
				})
				.then (() =>{
					this.props.escondeAguardando();
					this.setState(prevState => ({ ...prevState, botoesHabilitados:true}));
					window.scrollTo(0, 0);
				});   
		}

		confirmarExclusao(grupo) {
			this.setState(prevState => ({ ...prevState, exibeModalExcluir: true, grupoAlvo: grupo, }));
		}

		fecharModais () {
			this.setState(prevState => ({ ...prevState, exibeModalExcluir:false,}));
		}

		excluirGrupo(){
			this.props.limpaMensagem();
			const grupo = this.state.grupoAlvo;
			let url = `/api/contrato/grupo-api/${grupo.id}`;
			const options = {
				method: 'delete',
				url,
				"data" : grupo,
			}
			this.props.mostraAguardando(); 
			this.setState(prevState => ({ ...prevState, botoesHabilitados:false}));

			api(options)
				.then(response => {
					const mensagem = `Grupo de API excluído com sucesso!`;
					this.carregarGruposContrato();
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível excluir o grupo de API.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					
				})
				.then (() =>{
					this.props.escondeAguardando();
					this.setState(prevState => ({ ...prevState, botoesHabilitados:true}));
				});   
			
			this.fecharModais();
		}

		limpar(){
			this.props.limpaMensagem();
			this.setState(prevState => ({ ...prevState, grupo: {id: '', nome: '', contratosAplicacoesFornecedoras: [],},}))
		}

		validaFormulario(){
			let mensagens = [];

			const grupo = this.state.grupo;
			const { nome, contratosAplicacoesFornecedoras } = grupo
			
			if(!nome|| nome.trim().length === 0 ){
				mensagens.push({mensagem: "Nome é obrigatório."})
			}

			if(contratosAplicacoesFornecedoras.length < 2){
				mensagens.push({mensagem: "É necessário selecionar pelo menos 2 API's."})
			}

			const constratoAplicacaoFornecedoraPrincipal=  contratosAplicacoesFornecedoras.filter(contratoApi => contratoApi.principal === true);

			if(constratoAplicacaoFornecedoraPrincipal.length === 0){
				mensagens.push({mensagem: "É necessário selecionar qual é a API principal do grupo."})
			} else if(constratoAplicacaoFornecedoraPrincipal.length > 1){
				mensagens.push({mensagem: "Selecione apenas uma API principal."})
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

	}

) // redux
); // router